import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { OrganizationProvider } from './contexts/OrganizationContext';
import { PlanProvider } from './contexts/PlanContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { SimulationProvider } from './contexts/SimulationContext';
import { SedeViewProvider } from './contexts/SedeViewContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import WebSocketManager from './components/WebSocketManager';

// Tailwind CSS
import './index.css';

// Estilos de Leaflet para el mapa
import 'leaflet/dist/leaflet.css';

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY} language="es">
      <ThemeProvider>
      <NotificationProvider>
        <AuthProvider>
          <ConfirmProvider>
          <OrganizationProvider>
            <PlanProvider>
            <SimulationProvider>
              <SedeViewProvider>
                <WebSocketManager />
                <App />
              </SedeViewProvider>
            </SimulationProvider>
            </PlanProvider>
          </OrganizationProvider>
          </ConfirmProvider>
        </AuthProvider>
      </NotificationProvider>
      </ThemeProvider>
      </GoogleReCaptchaProvider>
    </BrowserRouter>
  </React.StrictMode>
);
